import { render, staticRenderFns } from "./AvalaraEntityUseCode.vue?vue&type=template&id=20a70fec&"
import script from "./AvalaraEntityUseCode.vue?vue&type=script&lang=ts&"
export * from "./AvalaraEntityUseCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports